module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[25]268.6f3e477.woff2";